<template>

    <label class="switch">
        <input type="checkbox" class="switch-input" v-model="value">
        <span class="switch-track"><span class="switch-thumb"></span></span>
        <span class="switch-label">
            <AppIcon v-if="icon" :name="icon" class="switch-icon"/>
            <span>{{ title }}</span>
        </span>
    </label>

</template>


<script>

import AppIcon from './AppIcon.vue';

export default {
    name: 'ToggleSwitch',

    components: {
        AppIcon
    },

    data() {
        return {
            value: this.checked
        }
    },

    props: {
        title: {
            type: String,
            default: 'Переключатель'
        },
        icon: {
            type: String,
        },
        checked: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        value(val) {
            this.$emit('myData', val)
        },
        checked(val) {
            this.value = val
        }
    }
}

</script>


<style scoped>

.switch{
    display: inline-flex;
    align-items: center;
    gap: 10px;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    cursor: pointer;
}

.switch-input{
    position: absolute;
    width: 1px;
    height: 1px;
    opacity: 0;
    pointer-events: none;
}

.switch-track{
    position: relative;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;

    width: 36px;
    height: 20px;
    padding: 2px;

    background: var(--border);
    border-radius: 999px;

    transition: background-color 0.15s ease;
}

.switch-thumb{
    display: block;

    width: 16px;
    height: 16px;

    background: #ffffff;
    border-radius: 999px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);

    transition: transform 0.15s ease;
}

.switch-input:checked + .switch-track{
    background: var(--primary);
}

.switch-input:checked + .switch-track .switch-thumb{
    transform: translateX(16px);
}

.switch-input:focus-visible + .switch-track{
    box-shadow: 0 0 0 3px var(--ring);
}

.switch-label{
    display: inline-flex;
    align-items: center;
    gap: 6px;

    font-size: 14px;
    color: var(--foreground);
}

.switch-icon{
    width: 15px;
    height: 15px;
    color: var(--muted-foreground);
}

</style>
